__turbopack_context__.v({
  "srOnly": "styles-module-scss-module__9HdTGW__srOnly",
});
